import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=5dfb8e3f&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfb8e3f')) {
      api.createRecord('5dfb8e3f', component.options)
    } else {
      api.reload('5dfb8e3f', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=5dfb8e3f&", function () {
      api.rerender('5dfb8e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-225Jd7sYaMD7r/JS/videoIframe.vue"
export default component.exports